export interface ModalStackEntry {
  id: string;
  onClose: () => void;
  canDismiss: () => boolean;
}

const stack: ModalStackEntry[] = [];

export function push(entry: ModalStackEntry): void {
  stack.push(entry);
}

export function pop(): ModalStackEntry | undefined {
  return stack.pop();
}

export function peek(): ModalStackEntry | undefined {
  return stack[stack.length - 1];
}

export function remove(id: string): void {
  const index = stack.findIndex(entry => entry.id === id);
  if (index !== -1) {
    stack.splice(index, 1);
  }
}

export function size(): number {
  return stack.length;
}
